var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 413.269L73.0996 408.929L219.723 130.717L220.033 127.771L155.398 6.36427C149.983 -3.80576 134.738 -1.23442 132.961 10.1501L70 413.269Z",
    fill: "#FFC24A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8283 409.96L74.173 405.388L219.261 130.091L154.787 8.18965C149.429 -1.87383 135.822 0.691558 134.063 11.9568L71.8283 409.96Z",
    fill: "#FFA712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M267.153 219.605L315.278 170.317L267.139 78.4187C262.569 69.7198 249.81 69.6947 245.288 78.4187L219.569 127.469V131.647L267.153 219.605Z",
    fill: "#F4BD62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M266.294 217.551L313.081 169.634L266.294 80.5439C261.851 72.087 251.058 71.201 246.662 79.6823L220.807 129.493L220.034 132.039L266.294 217.551Z",
    fill: "#FFA50E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70 413.269L71.405 411.857L76.5097 409.782L264.129 222.86L266.506 216.389L219.703 127.202L70 413.269Z",
    fill: "#F6820C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M273.162 507.538L442.961 412.84L394.472 114.211C392.955 104.868 381.493 101.174 374.805 107.873L70 413.269L238.826 507.53C249.495 513.487 262.489 513.49 273.162 507.538Z",
    fill: "#FDE068"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M441.439 412.045L393.319 115.684C391.813 106.412 382.281 102.575 375.645 109.223L71.8825 412.689L238.854 506.017C249.442 511.929 262.338 511.932 272.929 506.025L441.439 412.045Z",
    fill: "#FCCA3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M273.162 504.748C262.489 510.7 249.495 510.697 238.826 504.74L71.3598 411.833L70 413.269L238.826 507.53C249.495 513.487 262.489 513.49 273.162 507.538L442.961 412.84L442.545 410.281L273.162 504.748Z",
    fill: "#EEAB37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/Firebase.c869220ae946bf5f2c037357758659da.svg";
export { ForwardRef as ReactComponent };